var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconreload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M10.417 4.75c1.16 0 2.259.38 3.167 1.07l-2.102 1.978 5.347.574L16.578 3l-2.132 2.008a6.37 6.37 0 0 0-4.03-1.425A6.424 6.424 0 0 0 4 10h1.167a5.256 5.256 0 0 1 5.25-5.25M10.417 15.25a5.2 5.2 0 0 1-3.168-1.07l2.102-1.979-5.347-.573L4.255 17l2.132-2.008a6.37 6.37 0 0 0 4.03 1.425A6.424 6.424 0 0 0 16.833 10h-1.166a5.256 5.256 0 0 1-5.25 5.25"
})));
export { SvgIconreload as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.reload.ff1a88ce.svg";